export const getInputSizeByRequest = (uuid: string) => {
  return `${window.location.host}/group_buy_items/${uuid}/group_buy_requests/new`
}

export const expiredDateFormat = (date: Date | null) => {
  if (date) {
    const day = date.getDate() > 9 ? date.getDate() : '0' + date.getDate()
    return `${date.getFullYear()}年${date.getMonth() + 1}月${day}日`
  }
  return ''
}
